// src/MapPage/MapPage.js
import React, { useEffect } from 'react';

const MapPage = () => {
  useEffect(() => {
    const iframe = document.querySelector('.map-iframe');
    iframe.onload = () => {
      console.log('Map iframe loaded successfully.');
    };
    iframe.onerror = (error) => {
      console.error('Error loading map iframe:', error);
    };
  }, []);

  return (
    <div className="map-container">
      <iframe
        src="https://map.econspicuity.com/"
        className="map-iframe"
        title="Embedded Map"
        style={{ width: '100%', height: '600px', border: 'none' }}
      ></iframe>
    </div>
  );
};

export default MapPage;
